import env from 'pages/MyAccount/utils/env';
import request from './request';

export const validateAddress = (formData) => {
  const requestUrl = `${env.growth}/location/verify-address`;
  const data = JSON.stringify(formData);
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
};

export const getStatesByCountryId = (countryId) => {
  return request(
    `${env.localization}/states/by-country-id/${countryId}`,
    'GET',
    {
      'FFF-Auth': 'V1.2',
    }
  );
};
